import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-2"
}
const _hoisted_2 = { class: "row mb-0 small" }
const _hoisted_3 = { class: "col-sm-5 text-muted text-capitalize-first" }
const _hoisted_4 = { class: "col-sm-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('statistic.counterparties.view_stats_title'),
    "dialog-class": "modal-lg",
    modelValue: _ctx.isVisible,
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isVisible = $event))
  }, {
    default: _withCtx(() => [
      (_ctx.item)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("dl", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: field.key
                }, [
                  _createElementVNode("dt", _hoisted_3, _toDisplayString(field.label), 1),
                  _createElementVNode("dd", _hoisted_4, _toDisplayString(field.value(_ctx.item)), 1)
                ], 64))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"])),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}